// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#addAssignmentsWithLibraryModal .filterRow {
  margin-left: 15px;
  display: flex;
  justify-content: flex-start;
}
#addAssignmentsWithLibraryModal .filterRow .keyword {
  padding-left: 1rem;
  padding-bottom: 0.2rem;
  padding-top: 0.3rem;
  width: 60%;
  font-size: 14px;
  margin-right: 1rem;
}
#addAssignmentsWithLibraryModal .filterRow .lookIn {
}
#addAssignmentsWithLibraryModal .filterRow .lookIn select {
  border: 1px solid black;
}

/* Keyword search results title */
#addAssignmentsWithLibraryModal .searchResultsTitle {
  font-style: italic;
  font-size: 16px;
  margin-left: 30px;
  margin-top: 1.5rem;
}

/* Assignment names selection */
#addAssignmentsWithLibraryModal .selectAssignments {
  background-color: white;
  margin-top: 1rem;
  margin-left: 15px;
  min-height: 160px;
  max-height: 530px;
}
#addAssignmentsWithLibraryModal .selectAssignments .title {
  font-size: 16px;
  font-weight: bold;
  margin-top: 1rem;
  margin-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}
#addAssignmentsWithLibraryModal .selectAssignments .title.error {
  color: #e32b1e;
  font-weight: bold;
  font-size: 14px;
  padding-top: 1rem;
}

#addAssignmentsWithLibraryModal .selectAssignments p {
  font-size: 12px;
  font-weight: normal;
  margin-left: 30px;
}
#addAssignmentsWithLibraryModal .selectAssignments p.error {
  color: #e32b1e;
  font-weight: bold;
  font-size: 14px;
  padding-top: 1rem;
}

#addAssignmentsWithLibraryModal .selectAssignments .list {
  list-style: none;
  padding-left: 2rem;
  margin-left: 30px;
  margin-top: 1rem; /* override a bootstrap class */
}

#addAssignmentsWithLibraryModal .assignmentResults {
  overflow-y: scroll;
  height: 375px;
  padding-top: 0px;
  padding-left: 1px;
  position: relative;
}

#addAssignmentsWithLibraryModal .modal-dialog .modal-content .modal-body table {
  margin-bottom: 0px !important;
}

#addAssignmentsWithLibraryModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  thead
  tr {
  height: 45px;
}

#addAssignmentsWithLibraryModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  tbody
  tr {
  height: 40px;
}

#addAssignmentsWithLibraryModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  tr
  button {
  background-color: #dfdfdf;
  border: 1px #dedede;
  font-weight: bold;
}

#addAssignmentsWithLibraryModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  tbody
  a {
  font-size: 12px;
}

#addAssignmentsWithLibraryModal
  .modal-dialog
  .modal-content
  .modal-body
  table
  tbody
  td {
  padding-left: 10px;
  overflow-wrap: break-word;
}

#addAssignmentsWithLibraryModal .selectAssignments .selectAll {
  font-size: 12px;
}

/* On the audience tab, compress things in sublists */
#addAssignmentsWithLibraryModal .selectAssignments .list.subList {
  margin-top: 0;
}
/* On the audience tab, compress things in sublists */
#addAssignmentsWithLibraryModal .selectAssignments .list.subList li {
  margin-top: 0;
}

.nav-pills.nav-wizard {
  margin-top: 2rem;
  margin-left: 15px;
}
.nav-pills.nav-wizard > li {
  position: relative;
  overflow: visible;
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  width: 33%;
}
.nav-pills.nav-wizard > li + li {
  margin-left: 3px;
  width: 33%;
}
.nav-pills.nav-wizard > li:first-child {
  border-left: 0;
}
.nav-pills.nav-wizard > li:first-child a {
  border-radius: 5px 0 0 5px;
}
.nav-pills.nav-wizard > li:last-child {
  border-right: 0;
}
.nav-pills.nav-wizard > li:last-child a {
  border-radius: 0 5px 5px 0;
}
.nav-pills.nav-wizard .wide {
  width: 49%;
}

.nav-pills.nav-wizard > li a {
  border-radius: 0;
  background-color: #fff;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 6px;
  padding-bottom: 5px;
  color: #d4d4d4;
  text-align: center;
  font-size: 12px;
}
.nav-pills.nav-wizard > li .nav-arrow {
  position: absolute;
  top: 0px;
  right: -20px;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 14px 0 14px 20px;
  border-color: transparent transparent transparent #fff;
  z-index: 150;
}
.nav-pills.nav-wizard > li .nav-wedge {
  position: absolute;
  top: 0px;
  left: -20px;
  width: 0px;
  height: 0px;
  border-style: solid;
  border-width: 14px 0 14px 20px;
  border-color: #fff #fff #fff transparent;
  z-index: 150;
}
.nav-pills.nav-wizard > li:hover .nav-arrow,
.nav-pills.nav-wizard > li.completed .nav-arrow {
  border-color: transparent transparent transparent #aaa;
}
.nav-pills.nav-wizard > li:hover .nav-wedge,
.nav-pills.nav-wizard > li.completed .nav-wedge {
  border-color: #aaa #aaa #aaa transparent;
}
.nav-pills.nav-wizard > li:hover a,
.nav-pills.nav-wizard > li.completed a {
  background-color: #aaa;
  color: black;
}
.nav-pills.nav-wizard > li.active .nav-arrow {
  border-color: transparent transparent transparent #22abe9;
}
.nav-pills.nav-wizard > li.active .nav-wedge {
  border-color: #22abe9 #22abe9 #22abe9 transparent;
}
.nav-pills.nav-wizard > li.active a {
  background-color: #22abe9;
  text-align: center;
  color: #fff;
}

/* Calendar picker styling on due date tab */
div.md-datepicker-calendar-pane {
  z-index: 1050 !important;
}
body.md-datepicker-is-showing {
  overflow: visible !important;
}

/* The footer */
#addAssignmentsWithLibraryModal .footer {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  margin-top: 4rem;
}
#addAssignmentsWithLibraryModal .footer button {
  margin-left: 1.5rem;
  margin-right: 15px;
  border: 2px solid white;
  border-radius: 13px;
}

#addAssignmentsWithLibraryModal .messaging {
  width: 100%;
  padding: 0px 15px;
  margin: 0;
}

#addAssignmentsWithLibraryModal .offeringOption {
  margin: 0px 0px -20px -25px;
  vertical-align: bottom;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/addAssignmentWithLibrary.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;AACA;AACA;AACA;EACE,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;;;EAOE,YAAY;AACd;;AAEA;;;;;;;EAOE,YAAY;AACd;;AAEA;;;;;;;EAOE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,eAAe;AACjB;;AAEA;;;;;;;EAOE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,aAAa;AACf;AACA,qDAAqD;AACrD;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,mCAAmC;EACnC,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,sDAAsD;EACtD,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,YAAY;AACd;AACA;;EAEE,sDAAsD;AACxD;AACA;;EAEE,wCAAwC;AAC1C;AACA;;EAEE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,iDAAiD;AACnD;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB","sourcesContent":["#addAssignmentsWithLibraryModal .filterRow {\n  margin-left: 15px;\n  display: flex;\n  justify-content: flex-start;\n}\n#addAssignmentsWithLibraryModal .filterRow .keyword {\n  padding-left: 1rem;\n  padding-bottom: 0.2rem;\n  padding-top: 0.3rem;\n  width: 60%;\n  font-size: 14px;\n  margin-right: 1rem;\n}\n#addAssignmentsWithLibraryModal .filterRow .lookIn {\n}\n#addAssignmentsWithLibraryModal .filterRow .lookIn select {\n  border: 1px solid black;\n}\n\n/* Keyword search results title */\n#addAssignmentsWithLibraryModal .searchResultsTitle {\n  font-style: italic;\n  font-size: 16px;\n  margin-left: 30px;\n  margin-top: 1.5rem;\n}\n\n/* Assignment names selection */\n#addAssignmentsWithLibraryModal .selectAssignments {\n  background-color: white;\n  margin-top: 1rem;\n  margin-left: 15px;\n  min-height: 160px;\n  max-height: 530px;\n}\n#addAssignmentsWithLibraryModal .selectAssignments .title {\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 1rem;\n  margin-left: 10px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n#addAssignmentsWithLibraryModal .selectAssignments .title.error {\n  color: #e32b1e;\n  font-weight: bold;\n  font-size: 14px;\n  padding-top: 1rem;\n}\n\n#addAssignmentsWithLibraryModal .selectAssignments p {\n  font-size: 12px;\n  font-weight: normal;\n  margin-left: 30px;\n}\n#addAssignmentsWithLibraryModal .selectAssignments p.error {\n  color: #e32b1e;\n  font-weight: bold;\n  font-size: 14px;\n  padding-top: 1rem;\n}\n\n#addAssignmentsWithLibraryModal .selectAssignments .list {\n  list-style: none;\n  padding-left: 2rem;\n  margin-left: 30px;\n  margin-top: 1rem; /* override a bootstrap class */\n}\n\n#addAssignmentsWithLibraryModal .assignmentResults {\n  overflow-y: scroll;\n  height: 375px;\n  padding-top: 0px;\n  padding-left: 1px;\n  position: relative;\n}\n\n#addAssignmentsWithLibraryModal .modal-dialog .modal-content .modal-body table {\n  margin-bottom: 0px !important;\n}\n\n#addAssignmentsWithLibraryModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  thead\n  tr {\n  height: 45px;\n}\n\n#addAssignmentsWithLibraryModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  tbody\n  tr {\n  height: 40px;\n}\n\n#addAssignmentsWithLibraryModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  tr\n  button {\n  background-color: #dfdfdf;\n  border: 1px #dedede;\n  font-weight: bold;\n}\n\n#addAssignmentsWithLibraryModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  tbody\n  a {\n  font-size: 12px;\n}\n\n#addAssignmentsWithLibraryModal\n  .modal-dialog\n  .modal-content\n  .modal-body\n  table\n  tbody\n  td {\n  padding-left: 10px;\n  overflow-wrap: break-word;\n}\n\n#addAssignmentsWithLibraryModal .selectAssignments .selectAll {\n  font-size: 12px;\n}\n\n/* On the audience tab, compress things in sublists */\n#addAssignmentsWithLibraryModal .selectAssignments .list.subList {\n  margin-top: 0;\n}\n/* On the audience tab, compress things in sublists */\n#addAssignmentsWithLibraryModal .selectAssignments .list.subList li {\n  margin-top: 0;\n}\n\n.nav-pills.nav-wizard {\n  margin-top: 2rem;\n  margin-left: 15px;\n}\n.nav-pills.nav-wizard > li {\n  position: relative;\n  overflow: visible;\n  border-right: 10px solid transparent;\n  border-left: 10px solid transparent;\n  width: 33%;\n}\n.nav-pills.nav-wizard > li + li {\n  margin-left: 3px;\n  width: 33%;\n}\n.nav-pills.nav-wizard > li:first-child {\n  border-left: 0;\n}\n.nav-pills.nav-wizard > li:first-child a {\n  border-radius: 5px 0 0 5px;\n}\n.nav-pills.nav-wizard > li:last-child {\n  border-right: 0;\n}\n.nav-pills.nav-wizard > li:last-child a {\n  border-radius: 0 5px 5px 0;\n}\n.nav-pills.nav-wizard .wide {\n  width: 49%;\n}\n\n.nav-pills.nav-wizard > li a {\n  border-radius: 0;\n  background-color: #fff;\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-top: 6px;\n  padding-bottom: 5px;\n  color: #d4d4d4;\n  text-align: center;\n  font-size: 12px;\n}\n.nav-pills.nav-wizard > li .nav-arrow {\n  position: absolute;\n  top: 0px;\n  right: -20px;\n  width: 0px;\n  height: 0px;\n  border-style: solid;\n  border-width: 14px 0 14px 20px;\n  border-color: transparent transparent transparent #fff;\n  z-index: 150;\n}\n.nav-pills.nav-wizard > li .nav-wedge {\n  position: absolute;\n  top: 0px;\n  left: -20px;\n  width: 0px;\n  height: 0px;\n  border-style: solid;\n  border-width: 14px 0 14px 20px;\n  border-color: #fff #fff #fff transparent;\n  z-index: 150;\n}\n.nav-pills.nav-wizard > li:hover .nav-arrow,\n.nav-pills.nav-wizard > li.completed .nav-arrow {\n  border-color: transparent transparent transparent #aaa;\n}\n.nav-pills.nav-wizard > li:hover .nav-wedge,\n.nav-pills.nav-wizard > li.completed .nav-wedge {\n  border-color: #aaa #aaa #aaa transparent;\n}\n.nav-pills.nav-wizard > li:hover a,\n.nav-pills.nav-wizard > li.completed a {\n  background-color: #aaa;\n  color: black;\n}\n.nav-pills.nav-wizard > li.active .nav-arrow {\n  border-color: transparent transparent transparent #22abe9;\n}\n.nav-pills.nav-wizard > li.active .nav-wedge {\n  border-color: #22abe9 #22abe9 #22abe9 transparent;\n}\n.nav-pills.nav-wizard > li.active a {\n  background-color: #22abe9;\n  text-align: center;\n  color: #fff;\n}\n\n/* Calendar picker styling on due date tab */\ndiv.md-datepicker-calendar-pane {\n  z-index: 1050 !important;\n}\nbody.md-datepicker-is-showing {\n  overflow: visible !important;\n}\n\n/* The footer */\n#addAssignmentsWithLibraryModal .footer {\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-end;\n  margin-top: 4rem;\n}\n#addAssignmentsWithLibraryModal .footer button {\n  margin-left: 1.5rem;\n  margin-right: 15px;\n  border: 2px solid white;\n  border-radius: 13px;\n}\n\n#addAssignmentsWithLibraryModal .messaging {\n  width: 100%;\n  padding: 0px 15px;\n  margin: 0;\n}\n\n#addAssignmentsWithLibraryModal .offeringOption {\n  margin: 0px 0px -20px -25px;\n  vertical-align: bottom;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
